
import '../scss/btf/btf.scss';
import MicroModal from "micromodal";
import { Menu } from './components/menu/menu';
import { Search } from './components/search/search';
import { scrollMenu } from './components/scrollMenu/scrollMenu';

class HideLoader {
	constructor() {
		document.body.querySelector('.loader').classList.add('opacize');
		setTimeout( () => { document.body.querySelector('.loader').classList.add('z-out'); });
	}
}

document.addEventListener('DOMContentLoaded', function() {
	
	MicroModal.init();
	
	new scrollMenu();

	if ( document.querySelector('.menu-btn') ) {
		new Menu();
	}

	if ( document.querySelector('.search-btn') ) {
		new Search();
	}


	if ( document.querySelector('.gallery') ) {
		import('./components/gallery/gallery').then( c => {
			document.querySelectorAll('.gallery').forEach( (gallery: HTMLElement) => {
				new c.Gallery( gallery );
			});
		});
	}

	if ( document.querySelector('.accordion') ) {
		import('./components/accordion/accordion').then( c => {
			document.querySelectorAll('.accordion').forEach( (accordionList: HTMLElement) => {
				new c.Accordion( accordionList );
			});
		});
	}

	if ( document.querySelector('.video-gallery') ) {
		import('./components/video-gallery/video-gallery').then( c => {
			document.querySelectorAll('.video-gallery').forEach( (gallery: HTMLElement) => {
				new c.VideoGallery( gallery );
			});
		});
	}

	var input = document.getElementById( 'file-upload' );
	var infoArea = document.getElementById( 'file-upload-filename' );

	if (input) {
		input.addEventListener( 'change', showFileName );

		function showFileName( this: HTMLElement, ev: Event ) {
			// the change event gives us the input it occurred in 
			ev.preventDefault();
			let file = (<HTMLInputElement>ev.target).files[0];
			infoArea.textContent = 'File selezionato: ' + file.name;
		}
	}


	let pageFound = false;
	if ( !pageFound ) {
		new HideLoader();
	}


}, false);

